import { useMemo, useState, useRef } from 'react';
import LOAD_STATUS from '@/constants/load-status';
import provideActivityLink from '@/components/provide-activity-link';
import apis from '@/apis';

// import { message } from 'antd'

function transformStatus(status, msg = '') {
  // isINit isLoading isFail isFirst
  const res = {
    isInit: false,
    isIng: false,
    isFail: false,
    isFirst: false,
    isSuccess: false,
    msg,
  };

  switch (status) {
    case LOAD_STATUS.INIT:
      res.isInit = true;
      break;
    case LOAD_STATUS.ING:
      res.isIng = true;
      break;
    case LOAD_STATUS.FAIL:
      res.isFail = true;
      break;
    case LOAD_STATUS.FIRST:
      res.isFirst = true;
      break;
    case LOAD_STATUS.SUCCESS:
      res.isSuccess = true;
      break;
    default:
      res.isInit = true;
      break;
  }

  return res;
}
function getSendFormData(isEdit, isChannel) {
  if (isEdit) return apis.updateActivity;
  if (isChannel) return apis.channelActivityAdd;
  return apis.createActivity;
}

export default function useCommitForm(isEdit) {
  const [status, setStatus] = useState(LOAD_STATUS.INIT);

  const statusRef = useRef(status);

  const isChannel = provideActivityLink.useActivityLink().pageType === provideActivityLink.themeActivityType.channel;

  const sendFormData = useMemo(() => getSendFormData(isEdit, isChannel), [isEdit, isChannel]);

  // useEffect(() => {
  //   if (status === LOAD_STATUS.ING) return message.loading('活动发布中...', 0)

  //   if (status === LOAD_STATUS.SUCCESS) {
  //     message.success('活动发布成功')
  //   } else if (status === LOAD_STATUS.FAILED) {
  //     message.error('活动发布失败')
  //   }
  // }, [status])

  const statusPush = status;

  function pushFormData(data) {
    if (!data) return;
    if (statusRef.status === LOAD_STATUS.ING) return;
    setStatus(LOAD_STATUS.ING);

    return sendFormData(data).then((res) => {
      if (res.ret === '0') {
        setStatus(LOAD_STATUS.SUCCESS);
      } else {
        setStatus(LOAD_STATUS.FAILED);
        throw res;
      }
      return res;
    });
  }

  return [transformStatus(statusPush, ''), pushFormData];
}
